import axios from "axios";
import { useEffect, useState } from "react";

import Footer, { plants } from "./Components/Footer";
import Glass from "./Components/Glass";
import LeftMenu from "./Components/LeftMenu";
import Time from "./Components/Time";
// import ThirdPersonController from "./Components/ThirdPersonController";
import World from "./Components/World";
import BG from "./asset/BG.png";
import company from "./asset/company.png";

// import testSvg from "./asset/test.svg";

function App() {
  const [s_hoverPlant, set_s_hoverPlant] = useState("");
  const [s_data, set_s_data] = useState({});
  // console.log("s_hoverPlant = ", s_hoverPlant);

  useEffect(() => {
    const fetchWeatherData = async () => {
      try {
        const requests = plants
          // .filter((plant) => plant.longitude && plant.latitude)
          .map((plant) =>
            axios
              .get(
                `https://api.open-meteo.com/v1/forecast?latitude=${plant.latitude}&longitude=${plant.longitude}&daily=dew_point_2m_mean,uv_index_max&hourly=wind_speed_10m,uv_index&current=wind_speed_10m,surface_pressure,relative_humidity_2m,temperature_2m`,
              )
              .then((res) => ({
                plant: plant.CN,
                data: {
                  "humidity": res.data.current.relative_humidity_2m + " %", // 濕度
                  "airPressure": res.data.current.surface_pressure + " mb", // 氣壓
                  "dewPoint": res.data.daily?.dew_point_2m_mean?.[0] + " °C", // 露點溫度
                  "windSpeed": res.data.hourly?.wind_speed_10m?.[0] + " km/h", // 風速
                  "uvIndex": res.data.daily?.uv_index_max?.[0] + "/10", // 紫外線指數
                  "temperature_2m": res.data.current.temperature_2m + " °C", // 溫度（°C）
                },
              })),
          );
        const results = await Promise.all(requests);
        const newData = results.reduce((acc, { plant, data }) => {
          acc[plant] = data;
          return acc;
        }, {});
        set_s_data(newData);
      } catch (error) {
        console.error("Error fetching weather data:", error);
      }
    };
    fetchWeatherData();
  }, []);
  return (
    <div
      className="App w-screen h-screen relative bg-top bg-no-repeat"
      style={{
        backgroundImage: `url(${BG})`,
        backgroundSize: "100% 100%",
      }}
    >
      <img src={company} alt="company" className="absolute top-0 left-0 w-[600px] h-[150px]" />
      <div
        className="card w-[200px] absolute top-[30px] right-[30px] z-[9999]"
        onClick={() => {
          window.open("https://sync.satdg.com:3344/pds/login", "_blank");
        }}
      >
        <div className="title">集團戰情</div>
        <div className="subtitle">SYNC</div>
      </div>
      <LeftMenu s_data={s_data} s_hoverPlant={s_hoverPlant} />
      <World s_hoverPlant={s_hoverPlant} />
      <Glass s_hoverPlant={s_hoverPlant} s_data={s_data} />

      <Footer set_s_hoverPlant={set_s_hoverPlant} />
    </div>
  );
}

export default App;
